module.exports = require('./browser/algorithms.json')



//////////////////
// WEBPACK FOOTER
// ./node_modules/browserify-sign/algos.js
// module id = 857
// module chunks = 12